import { useEffect } from 'react';
import {
  useEntityList,
  EntityAutocompletePicker,
  EntityFilter,
} from '@backstage/plugin-catalog-react';

interface CustomFilters {
  kind?: any;
  technologyFilter?: EntityRelationsDependsOnFilter;
}

class EntityRelationsDependsOnFilter implements EntityFilter {
  constructor(private values: string[]) {}
  getCatalogFilters() {
    return {
      'spec.relatedTechnologies.name': this.values,
    };
  }
}

export const ProjectTechnologyPicker = () => {
  const {
    filters: { kind, technologyFilter },
    updateFilters,
  } = useEntityList<CustomFilters>();

  const currentKind = String(kind?.value ?? '').toLowerCase();
  const isProject = currentKind === 'project';

  useEffect(() => {
    if (!isProject && technologyFilter) {
      updateFilters({ technologyFilter: undefined });
    }
  }, [isProject, technologyFilter, updateFilters]);

  if (!isProject) {
    return null;
  }

  return (
    <EntityAutocompletePicker
      label="Technologies"
      name={'technologies' as any}
      path="spec.relatedTechnologies.name"
      showCounts
      Filter={EntityRelationsDependsOnFilter}
    />
  );
};
